import { Component, input } from "@angular/core";

// text-overflow only works on a block-level element, not the flex container itself.
@Component({
  template: `<p class="cell-text p-text-footnote p-color-text-secondary">{{value()}}</p>`,
  styles: [
    `.cell-text { display: block; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
     :host-context(.cell-zoom-content) { overflow: visible !important; }
     :host-context(.cell-zoom-content) .cell-text { overflow: visible; overflow-wrap: anywhere; text-overflow: clip; white-space: normal; }`,
  ],
  host: { style: "display: block; min-width: 0; overflow: hidden;" },
})
export class DefaultCellRendererComponent {
  readonly value = input<string>();
}
